function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 8C22 12.42 18.42 16 14 16C9.58 16 6 12.42 6 8C6 3.58 9.58 0 14 0C18.42 0 22 3.58 22 8ZM18 8C18 5.8 16.2 4 14 4C11.8 4 10 5.8 10 8C10 10.2 11.8 12 14 12C16.2 12 18 10.2 18 8ZM0 25C0 21.14 6.26 18 14 18C21.74 18 28 21.14 28 25C28 28.86 21.74 32 14 32C6.26 32 0 28.86 0 25ZM4.04 25C4.58 25.92 8.08 28 14 28C19.92 28 23.42 25.92 23.96 25C23.42 24.08 19.92 22 14 22C8.08 22 4.58 24.08 4.04 25ZM25.9998 12C25.8368 12 25.6829 11.9815 25.532 11.9634L25.532 11.9634C25.4608 11.9549 25.3903 11.9464 25.3198 11.94C24.8598 13.26 24.1998 14.46 23.3398 15.52C24.1798 15.8 25.0598 16 25.9998 16C30.4198 16 33.9998 12.42 33.9998 8C33.9998 3.58 30.4198 0 25.9998 0C25.0598 0 24.1798 0.2 23.3398 0.48C24.1998 1.54 24.8598 2.76 25.3198 4.06C25.3904 4.05359 25.4609 4.04513 25.532 4.03658C25.6829 4.01847 25.8368 4 25.9998 4C28.1998 4 29.9998 5.8 29.9998 8C29.9998 10.2 28.1998 12 25.9998 12ZM29.9598 19.7001C29.4398 19.1001 28.8598 18.5801 28.2598 18.1001C34.9198 18.6401 39.9998 21.5201 39.9998 25.0001C39.9998 28.4801 34.9198 31.3601 28.2798 31.9401C28.8798 31.4601 29.4598 30.9401 29.9598 30.3401C30.6798 29.5001 31.2598 28.4601 31.6198 27.3201C34.1398 26.6201 35.6398 25.6001 35.9798 25.0201C35.6398 24.4401 34.1398 23.4001 31.6198 22.7201C31.2598 21.5801 30.6798 20.5401 29.9598 19.7001Z",
  fill: "#CAD1DC"
});

function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.45fc8aaa922aa5032d13ce375e0401bf.svg";
export { ForwardRef as ReactComponent };